// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "9c22c545f659e36e656fa1b6e717870ffa129014/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};